import ABKAccordion from "../../../global/components/ABKAccordionAlt";
import {AccordionData} from "../../../global/interfaces/AccordionData";
import useClientQuery from "../../../global/queries/useClientQuery";


const LicenseDataAccordion = () => {

    const {data: client} = useClientQuery();

    const Licensesdata: AccordionData[] = [
        {label: "Lizenzart", size: 6, value: client?.lizenzart},
        {label: "ABK-Nummer", size: 6, value: client?.nummer},
        {label: "Anwendername", size: 6, value: client?.anwendername},
        {label: "Lizenzschlüssel", size: 6, value: client?.xkukennwort},
    ]

    if (client?.lizenznamen) {
        client?.lizenznamen.forEach(lizenz => {
            Licensesdata.push(
                {label: "weiterer Anwendername", size: 6, value:lizenz},
                {label: "", size: 6, value: ""},
            )
        })

    }

    return <ABKAccordion isInput={false} accordionTitle="Lizenzdaten" data={Licensesdata} />
}

export default LicenseDataAccordion;